export default __webpack_public_path__ + "static/media/food-secure-mig-int.9fd36d56.csv";